import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { api } from "../components/api";
import { useSnackbar } from "../components/AppComponents/SnackBarProvider";
import { MESSAGE, SEVERITY } from "../utils/messages";

export const useDeskEmailQuery = (query) =>
  useQuery({
    queryKey: ["deskEmailList", query],
    queryFn: () => api.desk.getDeskEmails(query),
    keepPreviousData: true,
    select: (data) => {
      return data?.data;
    },
    onSuccess: (data) => {},
    onError: (error) => {
      console.error("Error:", error);
    },
  });

export const useGetByEmailListId = (id, responseHandler) =>
  useQuery({
    queryKey: ["deskByEmailListId", id],
    queryFn: () => api.desk.getByEmailListId(id),
    enabled: !!id,
    keepPreviousData: true,
    select: (data) => {
      return data?.data;
    },
    onSuccess: (data) => {
      responseHandler(data);
    },
    onError: (error) => {
      console.error("Error:", error);
    },
  });

export const useGetAssetList = (id, query, updateMappedAssetDocuments) => {
  const { updateSnackbar } = useSnackbar();
  return useQuery({
    queryKey: ["getAssetList", id],
    queryFn: () => api.desk.getAssetList(id, query),
    enabled: !!id,
    keepPreviousData: true,
    select: (data) => {
      return data?.data;
    },
    onSuccess: (data) => {
      updateMappedAssetDocuments?.(data);
      // updateSnackbar({
      //   severity: SEVERITY.success,
      //   message: MESSAGE.customerAssets,
      // });
    },
    onError: (error) => {
      updateSnackbar({
        severity: SEVERITY.error,
        message: error?.message,
      });
      console.error("Error:", error);
    },
  });
};

export const useCloseTheDesk = (id, responseHandler) => {
  const { updateSnackbar } = useSnackbar();

  return useMutation({
    mutationKey: ["closeTheDesk", id],
    mutationFn: () => api.desk.closeTheDeskbyId(id),
    onSuccess: (data) => {
      responseHandler?.();
      updateSnackbar({
        message: MESSAGE.deskStatusUpdated,
        severity: SEVERITY.success,
      });
    },
    onError: (error) => {
      console.error("Error:", error);
      const errorMessage = error?.message || "An error occurred.";

      updateSnackbar({
        message: errorMessage,
        severity: SEVERITY.error,
      });
    },
  });
};
export const useDocAssetMappingMutation = (options = {}) => {
  const { updateSnackbar } = useSnackbar();
  return useMutation({
    mutationFn: (payload) => api.desk.docAssetMapping(payload),
    select: (data) => data?.data,
    onSuccess: (data) => {
      if (options.onSuccess) {
        options.onSuccess(data);
      }
      updateSnackbar({
        severity: SEVERITY.success,
        message: data?.message,
      });
    },
    onError: (error) => {
      updateSnackbar({
        severity: SEVERITY.error,
        message: error?.message,
      });
      console.error("Error", error);
    },
  });
};

export const useGetDocumentViewMutation = (id) =>
  useMutation({
    mutationFn: (payload) => api.desk.getDocumentView(payload),
    select: (data) => data?.data,
    onSuccess: (data) => {},
    onError: (error) => {
      console.error("Error", error);
    },
  });

export const useGetDocumentView = (id) =>
  useQuery({
    queryKey: ["documentView", id],
    queryFn: () => api.desk.getDocumentView(id),
    enabled: !!id,
    keepPreviousData: true,
    select: (data) => {
      return data?.data;
    },
    onSuccess: (data) => {},
    onError: (error) => {
      console.error("Error:", error);
    },
  });

export const useAssetUnMappingMutation = (assetMapHandler) => {
  const { updateSnackbar } = useSnackbar();
  return useMutation({
    mutationFn: (payload) => api.desk.assetUnMapping(payload),
    onSuccess: (data) => {
      assetMapHandler?.();
      updateSnackbar({
        severity: SEVERITY.success,
        message: data?.message,
      });
    },
    onError: (error) => {
      updateSnackbar({
        severity: SEVERITY.error,
        message: error?.message,
      });
      console.error("Error", error);
    },
  });
};

export const useDeskCustomerUpdate = (id, deskUpdateHandler) => {
  const { updateSnackbar } = useSnackbar();
  return useMutation({
    mutationFn: (payload) => api.desk.deskCustomerMap(id, payload),
    onSuccess: (data) => {
      deskUpdateHandler(false);
      updateSnackbar({
        severity: SEVERITY.success,
        message: data?.message,
      });
    },
    onError: (error) => {
      updateSnackbar({
        severity: SEVERITY.error,
        message: error?.message,
      });
      console.error("Error", error);
    },
  });
};
export const useGetFamilyNameQuery = (email) =>
  useQuery({
    queryKey: ["familyName", email],
    queryFn: () => api.desk.getFamilyName(email),
    keepPreviousData: true,
    select: (data) => {
      return data?.data;
    },
    onSuccess: (data) => {},
    onError: (error) => {
      console.error("Error:", error);
    },
  });

export const useRejectionMutation = (options = {}) => {
  const { updateSnackbar } = useSnackbar();
  return useMutation({
    mutationFn: (payload) => api.desk.rejection(payload),

    select: (data) => data?.data,
    onSuccess: (data) => {
      if (options.onSuccess) {
        options.onSuccess(data);
      }
      updateSnackbar({
        severity: SEVERITY.success,
        message: data?.message,
      });
    },
    onError: (error) => {
      updateSnackbar({
        severity: SEVERITY.error,
        message: error?.message,
      });
      console.error("Error", error);
    },
  });
};
export const useDeskDashboardQuery = (query) =>
  useQuery({
    queryKey: ["deskDashboard", query],
    queryFn: () => api.desk.getDeskDashboard(query),
    keepPreviousData: true,
    select: (data) => {
      return data?.data;
    },
    onSuccess: (data) => {},
    onError: (error) => {
      console.error("Error:", error);
    },
  });
export const useMetricsQuery = (query) =>
  useQuery({
    queryKey: ["metrics", query],
    queryFn: () => api.desk.getMetrics(query),
    keepPreviousData: true,
    select: (data) => {
      return data?.data;
    },
    onSuccess: (data) => {},
    onError: (error) => {
      console.error("Error:", error);
    },
  });

export const useCreateTemplate = () => {
  const queryClient = useQueryClient();
  const { updateSnackbar } = useSnackbar();
  return useMutation({
    mutationFn: (query) => api.desk.createTemplate(query),
    onSuccess: (data) => {
      queryClient.invalidateQueries(["template"]);
      updateSnackbar({
        severity: SEVERITY.success,
        message: data?.message,
      });
    },
    onError: (error) => {
      updateSnackbar({
        severity: SEVERITY.error,
        message: error?.message,
      });
      console.error("Error:", error);
    },
  });
};
// export const useTemplate = (query) => 
//   useQuery({
//     queryKey: ["template", query],
//     queryFn: () => api.desk.getTemplate(query),
//     keepPreviousData: true,
//     select: (data) => {
//       return data?.data;
//     },
//     onSuccess: (data) => {},
//     onError: (error) => {
//       console.error("Error:", error);
//     },
//   });

export const useTemplate = (query) =>
  useQuery({
    queryKey: ["template", query],
    queryFn: async () => {
      try {
        const res = await api.desk.getTemplate(query);
        // When success
        if (res?.status === 200) {
          return res?.data ?? [];
        }
        // In case API returns 404 in success flow (rare)
        if (res?.status === 404) {
          return [];
        }
        return [];
      } catch (err) {
        // Axios-like error → err.response.status
        if (err?.response?.status === 404) {
          return [];
        }
        // Your API format → err.status
        if (err?.status === 404) {
          return [];
        }
        throw err; // rethrow other errors
      }
    },
    keepPreviousData: true,
  })
export const useDeleteTemplate = () => {
  const { updateSnackbar } = useSnackbar();
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ["deleteTemplate"],
    mutationFn: (id) => api.desk.deleteTemplate(id),
    onSuccess: (data) => {
      queryClient.invalidateQueries(["template"]);
      updateSnackbar({
        severity: SEVERITY.success,
        message: data?.message,
      });
    },
    onError: (error) => {
      updateSnackbar({
        severity: SEVERITY.error,
        message: error?.message,
      });
      console.error("Error:", error);
    },
  });
};
export const useUpdateTemplateMutation = (id) => {
  const { updateSnackbar } = useSnackbar();
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload) => api.desk.updateTemplate(id, payload),

    select: (data) => data?.data,
    onSuccess: (data) => {
      updateSnackbar({
        severity: SEVERITY.success,
        message: data?.message,
      });
      queryClient.invalidateQueries(["template"]);
    },
    onError: (error) => {
      updateSnackbar({
        severity: SEVERITY.error,
        message: error?.message,
      });
      console.error("Error", error);
    },
  });
};
export const useSentTemplateMailMutation = () => {
  const { updateSnackbar } = useSnackbar();
  return useMutation({
    mutationFn: (payload) => api.desk.sentTemplateMail(payload),

    select: (data) => data?.data,
    onSuccess: (data) => {
      updateSnackbar({
        severity: SEVERITY.success,
        message: data?.message,
      });
    },
    onError: (error) => {
      updateSnackbar({
        severity: SEVERITY.error,
        message: error?.message,
      });
      console.error("Error", error);
    },
  });
};
export const useUpdateDocumentNameMutation = (options = {}) => {
  const { updateSnackbar } = useSnackbar();
  return useMutation({
    mutationFn: (payload) => api.desk.updateDocumentName(payload),
    onSuccess: (data) => {
      if (options.onSuccess) {
        options.onSuccess(data);
      }
      updateSnackbar({
        severity: SEVERITY.success,
        message: data?.message,
      });
    },
    onError: (error) => {
      updateSnackbar({
        severity: SEVERITY.error,
        message: error?.message,
      });
    },
  });
};
